//for computer
import Toplar1 from "../../images/toplar1.jpg";
import Toplar5 from "../../images/toplar5.jpg";
import Toplar7 from "../../images/toplar7.jpg";
import Toplar11 from "../../images/toplar11.jpg";
import Toplar13 from "../../images/toplar13.jpg";
//for phone
import Toplar2 from "../../images/toplar2.jpg";
import Toplar9 from "../../images/toplar9.jpg";
import Toplar10 from "../../images/toplar10.jpg";
import Toplar14 from "../../images/toplar14.jpg";

export const sliderData = [
  {
    image: Toplar1,
    title: "Zimski vrt",
    body: "Ste iz Dolenjske ali pa ste naše konce obiskali med izletom, počitnicami potjo in iščete, kje se lahko dobro najeste?",
  },
  {
    image: Toplar5,
    title: "Kotiček",
    body: "Imate radi bogato obložene pice?",
  },
  {
    image: Toplar7,
    title: "'Šank'",
    body: "Cenite prijeten ambient, prijazno    postrežbo, ki naredi dobrote na mizah še okusnejše?",
  },
  {
    image: Toplar11,
    title: "'Šank'",
    body: "Cenite prijeten ambient, prijazno    postrežbo, ki naredi dobrote na mizah še okusnejše?",
  },
  {
    image: Toplar13,
    title: "Zunanji vrt",
    body: "Pridite v PICERIJO TOPLAR v Zagradec.",
  },
];

export const sliderDataPhone = [
  {
    image: Toplar1,
    title: "'Ponk'",
    body: "Ste iz Dolenjske ali pa ste naše konce obiskali med izletom, počitnicami potjo in iščete, kje se lahko dobro najeste?",
  },
  {
    image: Toplar9,
    title: "Kotiček",
    body: "Imate radi bogato obložene pice?",
  },
  {
    image: Toplar10,
    title: "Prijeten prostor",
    body: "Cenite prijeten ambient, prijazno    postrežbo, ki naredi dobrote na mizah še okusnejše?",
  },
  {
    image: Toplar14,
    title: "Zunanji vrt",
    body: "Pridite v PICERIJO TOPLAR v Zagradec.",
  },
];
